module.exports = __webpack_public_path__ + "img/male.439d3efa.svg";